var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHangar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,117.622c-141.158,0-256,114.84-256,256c0,11.463,9.294,20.757,20.757,20.757c5.323,0,10.164-2.022,13.838-5.317 c3.674,3.295,8.514,5.317,13.838,5.317h124.541H256h83.027h124.541c5.323,0,10.164-2.022,13.838-5.317 c3.674,3.295,8.514,5.317,13.838,5.317c11.463,0,20.757-9.294,20.757-20.757C512,232.462,397.158,117.622,256,117.622z  M235.243,352.865H193.73v-41.513h41.513V352.865z M318.27,352.865h-41.513v-41.513h41.513V352.865z M359.784,352.865v-62.27 c0-11.463-9.294-20.757-20.757-20.757H256h-83.027c-11.463,0-20.757,9.294-20.757,20.757v62.27H70.335 C80.694,259.591,160.008,186.811,256,186.811s175.305,72.78,185.665,166.054H359.784z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangar);
export default __webpack_public_path__ + "static/media/hangar.0a187de30bad9deb1eff531b9cc3137d.svg";
export { ForwardRef as ReactComponent };